import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ImageCropper from '../../components/ImageCropper';
import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../App';
import { addAsset } from '../../api/Assets';
import Spinner from 'react-bootstrap/esm/Spinner';

function EditClubIconModal(props) {
  const [imageToCrop, setImageToCrop] = useState(undefined);
  const [croppedImage, setCroppedImage] = useState(undefined);
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [updating, setUpdating] = useState(false);
  const userContext = useContext(UserContext);

  useEffect(() => {
    setImageToCrop(undefined);
    setForm({});
  }, [props.show]);

  const ALLOWED_IMAGE_TYPES = ['image/png', 'image/jpeg'];

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });

    if (!!errors[field]) {
      setErrors({
        ...errors,
        [field]: null,
      });
    }
  };

  const findFormErrors = () => {
    const { base64 } = form;
    let initialSplit = base64.split(':');
    let base64type = initialSplit[1].split(';')[0];
    const newErrors = {};
    // base64 errors
    if (!base64) {
      newErrors.base64 = 'Du måste välja en bild.';
    } else if (ALLOWED_IMAGE_TYPES.includes(base64type) === false) {
      newErrors.base64 = 'Tillåtna filformat JPEG, PNG.';
    } else if (base64.length * (3 / 4) > 2048000) {
      newErrors.base64 = 'Bilden är för stor. Maximal filstorlek 2 MB.';
    }

    return newErrors;
  };

  const handleSubmit = async () => {
    props.setImageUpdated(false);
    setUpdating(true);
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setUpdating(false);
    } else {
      const values = {
        name: userContext.user?.clubName + ' Logo',
        type: 0, // 0 for image
        data: croppedImage,
      };
      const result = await addAsset(values);
      if (result) {
        switch (result.statusCode) {
          case 200:
            props.setImageUpdated(true);
            break;
          default:
            break;
        }
        props.onHide();
        setImageToCrop(undefined);
        setUpdating(false);
      }
    }
  };

  const onUploadFile = (event) => {
    if (ALLOWED_IMAGE_TYPES.includes(event.target.files[0].type)) {
      let reader = new FileReader();

      reader.addEventListener('load', () => {
        setImageToCrop(reader.result.toString() || '');
      });

      reader.readAsDataURL(event.target.files[0]);
    } else {
      setErrors({
        base64: 'Tillåtna filformat JPEG, PNG.',
      });
    }
  };

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      centered
      backdrop='static'
      aria-labelledby='contained-modal-title-vcenter'
      className='p-3'
    >
      <Modal.Header closeButton>
        <Modal.Title>Ladda upp bild</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <p>Tillåtna filformat JPEG, PNG. Max filstorlek 2 MB.</p>
          <Form.Group>
            <Form.Control
              type='file'
              multiple={false}
              accept='image/png, image/jpeg'
              onClick={() => setImageToCrop(undefined)}
              onChange={(e) => onUploadFile(e)}
              isInvalid={!!errors.base64}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.base64}
            </Form.Control.Feedback>
          </Form.Group>
          {imageToCrop && (
            <ImageCropper
              imageToCrop={imageToCrop}
              onImageCropped={(croppedImage) => {
                setCroppedImage(croppedImage);
                setField('base64', croppedImage);
              }}
            />
          )}
        </Form>
        {imageToCrop ? (
          <p>
            Beskär bilden genom att justera och positionera ramen över bilden.
          </p>
        ) : (
          <></>
        )}
      </Modal.Body>
      <Modal.Footer className='d-flex justify-content-between'>
        <Button
          onClick={() => {
            props.onHide();
            setImageToCrop(undefined);
          }}
          variant='outline-secondary'
        >
          Avbryt
        </Button>
        <Button onClick={handleSubmit}>
          {updating ? (
            <>
              <Spinner
                as='span'
                animation='border'
                size='sm'
                role='status'
                aria-hidden='true'
                className='me-2'
              />
              <span className='visually-hidden'>Loading...</span>
              Spara
            </>
          ) : (
            'Spara'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditClubIconModal;
